import React from 'react';
import classnames from 'classnames';
import { Spinner } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import BackgroundImages, {
  BG_IMAGES,
} from 'v2/common/Background/BackgroundImages';
import Pagination from 'v2/common/Pagination/Pagination';
import TabNosReults from 'v2/common/TabNosReults/TabNosReults';
import useGetPageNumber from 'v2/hooks/useGetPageNumber';
import { SearchEntity } from 'v2/models';
import { useArtificialResponses } from 'v2/queries/useArtificialResponses';
import { FreeResponseItem } from '../FreeResponseItem/FreeResponseItem';
import styles from './freeSearchResponses.module.scss';

interface FreeSearchResponsesProps {
  search: SearchEntity;
}

export const FreeSearchResponses = ({ search }: FreeSearchResponsesProps) => {
  const location = useLocation();
  const history = useHistory();

  const changePage = (page: number) => {
    const params = new URLSearchParams({ page: page.toString() });
    history.push({ pathname: location.pathname, search: params.toString() });
    window.scrollTo(0, 0);
  };

  const page = useGetPageNumber({
    onNotValidPageNumber: changePage,
    from: 'query',
  });

  const { data, isLoading } = useArtificialResponses({
    search,
    page,
  });
  const { count: responsesCount = 0, results: responses } = data || {};

  if (isLoading) {
    return (
      <div data-testid="spinner" className="loadingIndicatorContainer">
        <Spinner animation="border" />
      </div>
    );
  }

  if (responsesCount === 0) {
    return (
      <TabNosReults
        message={`There are no responses${search.active ? ' yet!' : ''}`}
        showTopImage
      />
    );
  }

  const showPagination = responsesCount > 10;

  return (
    <div
      className={classnames('table-container', 'fix-bg-images')}
      data-testid={'FreeSearchResponses'}
    >
      <div className={classnames(styles.subscribeMessage)}>
        <p>
          Subscribe to receive countless more responses that can supply you with
          the data you are looking for.
        </p>
        <Link
          to="/settings/subscription"
          className={classnames('btn btn-outline-primary')}
        >
          subscribe
        </Link>
      </div>
      <div>
        {responses?.map((response) => (
          <FreeResponseItem key={search.id} response={response} />
        ))}
      </div>
      {showPagination && (
        <Pagination
          totalCountOfItems={responsesCount}
          callBack={(pageSelected) => {
            changePage(pageSelected);
          }}
          currentPageOfItems={page}
        />
      )}
      <BackgroundImages
        showTopImage={false}
        bottomImage={BG_IMAGES.bottomRightYellowBgImage}
      />
    </div>
  );
};
